import Header from './Header';
import Welcome from './Welcome';
import VideoTour from './VideoTour';
import PaymentPlan from './paymentPlan';
import Footer from './Footer';
import SalesTeam from './SalesTeam';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { WhiteLabelCompanyConfig } from '../../reducers/whitelabelSlices';
import WhitelabelWelcome from '../whitelabelLanding';
export const Login = () => {
  const token = localStorage.getItem('token');
  const [logoUrl, setLogoUrl] = useState();
  const [configData, setConfigData] = useState();
  const dispatch = useDispatch();

  const SKALEBOT_URL = process.env.REACT_APP_SKALEBOT_APP_URL;

  const isEnvUrlMatch =
    SKALEBOT_URL && window.location?.origin.toLowerCase() === SKALEBOT_URL.toLowerCase();
  const isLocalhost = window.location.hostname === 'localhost';

  const fetchData = () => {
    const payload = {
      appBaseUrl: window.location.origin,
    };
    try {
      dispatch(WhiteLabelCompanyConfig(payload))
        .unwrap()
        .then((res) => {
          setLogoUrl(res?.data?.logoUrl);
          setConfigData(res?.data);
        })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } catch (error) {
      console.error('Dispatch Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  if (token) return <Navigate to={'/'} replace />;
  else
    return (
      <div className={` flex flex-column w-full`}>
        <Header logoUrl={logoUrl} />
        {isEnvUrlMatch || isLocalhost ? (
          <>
            <Welcome />
            <VideoTour />
            {/* <PaymentPlan /> */}
            <SalesTeam />
            <Footer />
          </>
        ) : (
          <WhitelabelWelcome data={configData} />
        )}
      </div>
    );
};
